import React, { useEffect, useState } from "react";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';

import { Nav, Navbar, NavDropdown, Container } from 'react-bootstrap';

function Navheader({settings, setSettings}) {
  const [toggle, setToggle] = useState();
  const [showModal, setShowModal] = useState(false);

  function toggler() { setToggle(!toggle) }

  function logout() {
    axios.delete(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/users/sign_out.json`)
        .then(() => {
            localStorage.removeItem("user");
            window.location = "/";
        })
        .catch((error) => console.error(error));
}


  return (
    <>
      <Navbar collapseOnSelect expand="sm" className="navbar-custom" variant="dark" onToggle={toggler}>
        <Container >
          <Navbar.Brand href="/">PowerIQ</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/">Customers</Nav.Link>
            <Nav.Link href="/hadevices">Devices</Nav.Link>
          </Nav>
          <Nav className="justify-content-end">
          <NavDropdown style={{ right: 0 }} title={JSON.parse(localStorage.getItem('user')).first_name} id="collasible-nav-help">
                            <NavDropdown.Item onClick={() => logout()}>Logout</NavDropdown.Item>
                        </NavDropdown>
                      </Nav>
        </Container>
      </Navbar>
    </>
  );

}

export default Navheader;